import FilterTextInput from './FilterTextInput';
import FilterSelectInput from './FilterSelectInput';
import FilterLocationInput from './FilterLocationInput';
import FilterFileInput from './FilterFileInput';

export const FILTER_INPUT_COMPONENTS = {
  text: FilterTextInput,
  select: FilterSelectInput,
  multi_select: FilterSelectInput,
  number: FilterTextInput,
  date: FilterTextInput,
  url: FilterTextInput,
  location: FilterLocationInput,
  image: FilterFileInput,
  file: FilterFileInput
};